export function ContactPage() {
  return (
    <article className="oac-contact-page">
      <header className="oac-contact-page__header">
        <h1 className="oac-contact-page__heading oac-membership-page__heading">
          Contact
        </h1>
      </header>

      <div className="oac-contact-page__columns-grid">
        <section
          aria-labelledby="oac-contact-support"
          className="oac-contact-page__section"
        >
          <h2
            className="oac-contact-page__section-title"
            id="oac-contact-support"
          >
            Support
          </h2>

          <p className="oac-contact-page__description">
            For general questions, account assistance and platform support.
          </p>

          <a
            className="oac-contact-page__email"
            href="mailto:support@openappcart.com"
          >
            support@openappcart.com
          </a>
        </section>

        <section
          aria-labelledby="oac-contact-publishers"
          className="oac-contact-page__section"
        >
          <h2
            className="oac-contact-page__section-title"
            id="oac-contact-publishers"
          >
            Publishers
          </h2>

          <p className="oac-contact-page__description">
            For app publishing, submissions, updates and publisher-related
            enquiries.
          </p>

          <a
            className="oac-contact-page__email"
            href="mailto:publisher@openappcart.com"
          >
            publisher@openappcart.com
          </a>
        </section>

        <section
          aria-labelledby="oac-contact-response-time"
          className="oac-contact-page__section"
        >
          <h2
            className="oac-contact-page__section-title"
            id="oac-contact-response-time"
          >
            Response time
          </h2>

          <p className="oac-contact-page__description">
            We aim to respond within 2 business days.
          </p>
        </section>
      </div>
    </article>
  );
}
